import React from 'react';
import { Table, TableBody, TableRow, TableCell } from '@cko/primitives';
import { arrayRange } from '../../utils/array';
import { LoadingBlock } from '../LoadingBlock';
export const TablePlaceholder = ({ rows, cols, ...rest }) => {
    if (rows <= 0 || cols <= 0) {
        throw new Error('The rows and cols props should be positive numbers');
    }
    return (React.createElement(Table, { ...rest, "data-testid": "table-placeholder" },
        React.createElement(TableBody, null, arrayRange(1, rows).map((i) => (React.createElement(TableRow, { key: `table-placeholder-row-${i}` }, arrayRange(1, cols).map((h) => (React.createElement(TableCell, { key: `table-placeholder-cell-${h}` },
            React.createElement(LoadingBlock, null))))))))));
};
